import { createContext, useContext } from 'react'

export type AuthInfo = {
  mode: 'none' | 'local' | 'entra'
  accountName: string | null
  signOut: (() => void) | null
}

export const AuthContext = createContext<AuthInfo>({ mode: 'none', accountName: null, signOut: null })

export function useAuth(): AuthInfo {
  return useContext(AuthContext)
}
